import { BuildingType } from '@belimo-retrofit-portal/logic';
import { createSelector } from 'reselect';
import { getProjectDetails } from 'src/modules/project-view/selectors/getProjectDetails';

const map: Record<BuildingType, string> = {
  [BuildingType.OFFICE]: '90–150',
  [BuildingType.DATA_CENTER]: '800–1200',
  [BuildingType.EDUCATION_ELEMENTARY]: '50–110',
  [BuildingType.EDUCATION_HIGHER]: '110–160',
  [BuildingType.EDUCATION_OTHER]: '80–120',
  [BuildingType.ENTERTAINMENT_LEISURE]: '180–260',
  [BuildingType.GOVERNMENT]: '100–150',
  [BuildingType.HEALTH]: '110–180',
  [BuildingType.HOSPITAL]: '110–180',
  [BuildingType.HOTEL]: '170–240',
  [BuildingType.LIFE_SCIENCE]: '300–500',
  [BuildingType.RESTAURANT]: '90–170',
  [BuildingType.RETAIL]: '100–180',
  [BuildingType.WHOLESALE_RETAIL_TRADE]: '100–180',
};
export const getAnnualSavingPlaceholderValue = createSelector([
  getProjectDetails,
], (data) => map[data.data.building.type]);
